"use client";

import { useEffect, useState } from "react";
import { db } from "../firebase/firebaseConfig";
import { collection, onSnapshot } from "firebase/firestore";
import * as XLSX from "xlsx";
import "./ListaInvitados.css";

export default function ListaInvitados() {
  const [invitados, setInvitados] = useState([]);

  // Traer invitados en tiempo real
  useEffect(() => {
    const unsub = onSnapshot(collection(db, "asistencias"), (snapshot) => {
      const lista = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      setInvitados(lista);
    });

    return () => unsub();
  }, []);

  // Descargar Excel
  const descargarExcel = () => {
    const datosExcel = invitados.map(inv => ({
      Nombre: inv.nombre,
      Asistencia: inv.asistencia,
      Mensaje: inv.mensaje,
      "Fecha / Hora": inv.fecha?.toDate().toLocaleString() || ""
    }));

    const worksheet = XLSX.utils.json_to_sheet(datosExcel);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Invitados");
    XLSX.writeFile(workbook, "invitados.xlsx");
  };

  return (
    <div className="lista-invitados">
      <div className="card">
        <h2>Lista de Invitados</h2>
        <p className="total">
          Total confirmados: <span>{invitados.length}</span>
        </p>

        <div className="table-container">
          <table>
            <thead>
              <tr>
                <th>Nombre</th>
                <th>Asistencia</th>
                <th>Mensaje</th>
                <th>Fecha / Hora</th>
              </tr>
            </thead>
            <tbody>
              {invitados.map((inv, i) => (
                <tr key={inv.id}>
                  <td>{inv.nombre}</td>
                  <td>{inv.asistencia}</td>
                  <td>{inv.mensaje}</td>
                  <td>{inv.fecha?.toDate().toLocaleString() || ""}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <button className="boton-excel" onClick={descargarExcel}>
          Descargar Excel
        </button>
      </div>
    </div>
  );
}
